import React from "react";
import { useHistory, useParams } from 'react-router-dom';
import ConferenceLayout from "./index";
import queryString from 'query-string';

const BotConfLayout = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const query_data = queryString.parse(props.location.search);
    // const query_data = {
    //     name: "John Doe",
    //     email: "john.doe@example.com",
    //     headless:true,
    //     record:true,
    // };
    
    return <ConferenceLayout role={null} id={id} uid={null} history={history} payload={null} query_data={query_data} />

}   
export default BotConfLayout;